import 'phoenix_html'
import 'react-phoenix'

import {HoneybadgerErrorBoundary} from '@honeybadger-io/react'
import React from 'react'

import ClosePopup from './components/Marketplace/ClosePopup'
import FailedProvisioning from './components/Splash/FailedProvisioning'
import FlashMessage from './components/FlashMessage'
import HBContext, {honeybadger} from './honeyBadgerContext.js'
import InviteAccepted from 'js/components/Users/InviteAccepted'
import InviteCancelledAccount from 'js/components/SignUp/InviteCancelledAccount'
import InviteEmailError from 'js/components/Splash/InviteEmailError'
import InviteExpired from './components/SignUp/InviteExpired'
import InviteSignUp from './components/SignUp/InviteSignUp'
import JoinOrg from 'js/components/Users/JoinOrg'
import MarketplaceRegistrationError from './components/Marketplace/MarketplaceRegistrationError'
import MarketplaceSignUp from './components/Marketplace/SignUp'
import MarketplaceSpinner from './components/Splash/MarketplaceSpinner'
import Plans from './components/Plans/Plans'
import SignUp from './components/SignUp/SignUp'
import Splash from './components/Splash/Splash'
import Unverified from './components/Unverified/Unverified'
import UserWithoutAccount from './components/Users/UserWithoutAccount'

import '@influxdata/clockface/dist/index.css'
import '../css/app.scss'
import {TailoredQuestionnaire} from './components/TailoredQuestionnare/TailoredQuestionnaire'

const HandleErrors = (AppComponent) => (props) => (
  <HoneybadgerErrorBoundary honeybadger={honeybadger}>
    <HBContext.Provider value={honeybadger}>
      <AppComponent {...props} />
    </HBContext.Provider>
  </HoneybadgerErrorBoundary>
)

// Google Tag Manager event collection
window.dataLayer = window.dataLayer || []

/*
  React Phoenix components get rendered without
  an error Boundary unless wrapped here.
*/
window.Component = {
  ClosePopup: HandleErrors(ClosePopup),
  FailedProvisioning: HandleErrors(FailedProvisioning),
  FlashMessage: HandleErrors(FlashMessage),
  InviteAccepted: HandleErrors(InviteAccepted),
  InviteCancelledAccount: HandleErrors(InviteCancelledAccount),
  InviteEmailError: HandleErrors(InviteEmailError),
  InviteExpired: HandleErrors(InviteExpired),
  InviteSignUp: HandleErrors(InviteSignUp),
  JoinOrg: HandleErrors(JoinOrg),
  MarketplaceRegistrationError: HandleErrors(MarketplaceRegistrationError),
  MarketplaceSignUp: HandleErrors(MarketplaceSignUp),
  MarketplaceSpinner: HandleErrors(MarketplaceSpinner),
  Plans: HandleErrors(Plans),
  SignUp: HandleErrors(SignUp),
  Splash: HandleErrors(Splash),
  Personalize: HandleErrors(TailoredQuestionnaire),
  Unverified: HandleErrors(Unverified),
  UserWithoutAccount: HandleErrors(UserWithoutAccount),
}
